import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import Popup from 'reactjs-popup'
import ContactForm from '../estimate-form'

import {
  MenuLi,
  SubMenu,
  SubSection,
  SubSectionWrapper,
  SectionTitle,
  LogoSVG,
  PhoneNumberHeader,
  HeaderOuterContainer,
  NavOuterContainer,
  NavigationMobileUL,
  MobileSecondaryCTA,
  StickyContainer,
  LogoContainer,
  MenuMobile,
  MobileIconBurger,
  CTASectionWrapper,
  SiteTagline,
} from './components'
import { ColumnWrapper } from './ColumnWrapper'
import Logo from '../logo-svg'
import Button from '../button'
import { X } from 'react-feather'

import { getLocPhysicalAndCity as getValueTrackingParams } from '../../helpers/adRefTracking'

import { ServingCitiesText } from '../ServingCitiesText'
import { personalizedServingText } from '../../helpers/personalizedServingText'

let windowWidth = 0
if (typeof window !== `undefined`) {
  windowWidth = window.innerWidth
}

const itemsPerColumn = 7

const MainNavigation = ({
  mainNavigation,
  refCallback,
  level = 0,
  pageLocation,
}) => {
  let MenuItems = []

  const rows = [...Array(Math.ceil(mainNavigation.length / itemsPerColumn))]
  const menuRows = rows.map((row, idx) =>
    mainNavigation.slice(
      idx * itemsPerColumn,
      idx * itemsPerColumn + itemsPerColumn
    )
  )

  const MenuItem = (menuItem, index) => {
    const isParentOnSubPage =
      // only run this check on level 0 menu otherwise it'll be excessive and waste cpu resources
      level == 0 &&
      menuItem.submenu &&
      // first submenu
      menuItem.submenu[0].menuItems.filter(
        ({ subMenuSection, url: subMenuURL }) => {
          const exactPageMatch = subMenuURL == pageLocation
          const userIsOnSubmenuPage =
            subMenuSection &&
            subMenuSection[0].menuItems.filter(
              ({ url: layerTwoSubMenuUrl }) => {
                try {
                  // second submenu
                  // ex kitchen remodeling => kitchen cabinets
                  // kitchen cabinets is the lawyerTwoSubMenu
                  return layerTwoSubMenuUrl == pageLocation
                } catch (e) {
                  console.log('some error occured; preserved interactivity')
                  return false
                }
              }
            ).length > 0
          return (
            exactPageMatch ||
            userIsOnSubmenuPage ||
            (pageLocation.includes('blog') && subMenuURL.includes('blog')) ||
            (pageLocation.includes('offers') && subMenuURL.includes('offers'))
          )
        }
      ).length > 0

    return (
      <MenuLi
        key={index}
        className={
          (menuItem.submenu ? 'has-submenu ' : '') +
          (menuItem && menuItem.cssClasses ? menuItem.cssClasses : '') +
          (menuItem.subMenuSection ? ' has-subsection' : '')
        }
      >
        <Link
          to={menuItem.url ? menuItem.url : '#'}
          title={menuItem.title}
          activeClassName={'active'}
          partiallyActive={menuItem.url != '/'}
          className={`hover:color-primary ${isParentOnSubPage ? 'active' : ''}`}
        >
          {menuItem.name}
        </Link>

        {/* render submenu */}
        {menuItem && menuItem.submenu && (
          <SubMenu
            className={`submenu bg-color-primary-lg ${
              Math.ceil(menuItem.submenu[0].menuItems.length / itemsPerColumn) >
              1
                ? 'row'
                : ''
            }`}
          >
            <MainNavigation
              mainNavigation={menuItem.submenu[0].menuItems}
              level={level + 1}
            />
          </SubMenu>
        )}
        {menuItem && menuItem.subMenuSection && (
          <SubSectionWrapper
            ref={refCallback && refCallback(menuItem.name, index)}
          >
            {menuItem.subMenuSection.map((section) => (
              <SubSection
                className="subsection bg-color-primary-lg"
                key={section.id}
              >
                <MainNavigation
                  mainNavigation={section.menuItems}
                  level={level + 1}
                />
              </SubSection>
            ))}
          </SubSectionWrapper>
        )}
      </MenuLi>
    )
  }

  MenuItems = menuRows.map((row, i) => {
    return (
      <ColumnWrapper
        columns={
          level > 0 && Math.ceil(mainNavigation.length / itemsPerColumn) > 1
        }
        key={i}
      >
        {row.map(MenuItem)}
      </ColumnWrapper>
    )
  })
  return MenuItems
}

const CallToAction = (props) => {
  const popUpHandler = (close) => (
    <div className="p-2 block">
      <button
        style={{ borderWidth: '0', float: 'right' }}
        className="cursor-pointer d-block border-radius mt-3 mr-4 p-2 float-right m0-auto m-0-auto button__ButtonOuter-gFbSyU"
        onClick={() => {
          close()
        }}
      >
        <X color={'#333'} strokeWidth={'3'} className="d-block" />
      </button>
      <div className="p-3 py-4 block">
        <h2 className="mb-1 popupheading" style={{ lineHeight: '1.05' }}>
          Start with a FREE Quote!
        </h2>
        <ServingCitiesText path={props.pageProps.path} />
        <p
          style={{
            color: '#666',
            lineHeight: '1.5',
            fontSize: '.9em',
          }}
          className="mb-3 popupdesc"
        >
          If you would like to schedule a complimentary in-home design
          consultation and estimate or need more information on a product or
          service that we offer, please fill out the information below.
        </p>
        <ContactForm
          showServicesList={true}
          showLabels={true}
          showPlaceHolders={true}
          pageLocation={
            props.pageProps.location.href
              ? props.pageProps.location.href
              : 'Not provided'
          }
        />
      </div>
    </div>
  )

  return (
    <CTASectionWrapper>
      <div className="headeroneph">
        <div className="row">
          <div className="column headinfo ">
            <span className="givecalltoday">
              Give Us A Call Today!
              <br />
            </span>
            <PhoneNumberHeader
              href={'tel:' + props.companyInfo.phone}
              className="hover:text-color-primary"
            >
              {props.companyInfo.phone}
            </PhoneNumberHeader>
          </div>

          <div className="column divcentervertical estbuttonalign">
            <Popup
              trigger={
                <button
                  title={'FREE Estimate'}
                  style={{ borderWidth: '0' }}
                  className="border-radius button-style-primary button-style-white-outline border-0 cursor-pointer primary cta-button"
                >
                  FREE Estimate
                </button>
              }
              modal
              closeOnDocumentClick
            >
              {popUpHandler}
            </Popup>
          </div>
        </div>
      </div>
    </CTASectionWrapper>
  )
}

class Header extends React.Component {
  state = {
    headerOpen: false,
    windowWidth: windowWidth,
    defaultMenu: this.props.mainNavigation,
  }

  subSectionRefs = {}

  componentDidMount() {
    this.updatePhoneLoadScrollReveal()
    if (typeof window !== `undefined`) {
      window.addEventListener('resize', this.handleWindowResize)
    }
    const { campaigns = 'default' } = getValueTrackingParams()
    if (campaigns != 'default') {
      const matchingCampaignMenu = this.props.menus.filter(
        ({ node: { campaign } }) =>
          campaign.length > 0 ? campaign[0] == campaigns : false
      )

      if (matchingCampaignMenu.length > 0) {
        this.setState({
          ...this.state,
          defaultMenu: matchingCampaignMenu[0].node.menuItems,
        })
      }
    }
  }

  componentDidUpdate() {
    this.updatePhoneLoadScrollReveal()
  }

  componentWillUnmount() {
    if (typeof window !== `undefined`) {
      window.removeEventListener('resize', this.handleWindowResize)
    }
  }

  handleWindowResize = () => {
    if (typeof window !== `undefined`) {
      this.setState({ windowWidth: window.innerWidth })
    }
  }

  updatePhoneLoadScrollReveal = () => {
    // Temporarily disable CallRail swapping
    // try {
    //   window.CallTrk.swap()
    // } catch (e) {
    //   console.log('phone swap blocked')
    // }
  }

  toggleMobileMenuOverlay = (e) => {
    e.preventDefault()
    this.setState({
      headerOpen: (this.headerOpen = !this.headerOpen),
    })

    if (document.body.classList.contains('mobile-menu-overlay--open')) {
      document.body.classList.remove('mobile-menu-overlay--open')
    } else {
      document.body.classList.add('mobile-menu-overlay--open')
    }
  }

  refCallback = (name) => (ref) => {
    if (ref && typeof window !== `undefined`) {
      this.subSectionRefs[name] = ref
      if (
        this.subSectionRefs[name].getBoundingClientRect().right >
        window.innerWidth
      ) {
        this.subSectionRefs[name].classList.add('off-right')
      } else {
        this.subSectionRefs[name].classList.remove('off-right')
      }
    }
  }

  render() {
    return (
      <>
        {this.props.globalOffer && (
          <div className="notification-designer">
            <div className="container p-3 text-center font-bold">
              <span>
                {this.props.globalOffer.notificationBarText
                  ? this.props.globalOffer.notificationBarText
                  : this.props.globalOffer.title}
                &nbsp;
                <Link to={'/offers/' + this.props.globalOffer.slug + '/'}>
                  {this.props.globalOffer.notificationBarActionText
                    ? this.props.globalOffer.notificationBarActionText
                    : 'Learn more'}{' '}
                  →
                </Link>
              </span>
            </div>
          </div>
        )}
        <HeaderOuterContainer className="container-fluid bg-color-header-outer">
          <div className="container padding-0  bg-color-header-inner">
            <div className="row">
              <LogoContainer className="col-6 col-lg-4 d-flex align-items-center">
                <Link to="/" style={{ lineHeight: '0' }} aria-label="GVD Renovations">
                  <LogoSVG alt={this.props.siteTitle + ' Logo'}>
                    <Logo color="white-desktop" />
                  </LogoSVG>
                </Link>
              </LogoContainer>
              {this.props.siteDescription ? (
  <SiteTagline
    className="sitetaglinehead divcentervertical d-xl-flex col-xl-4 col-lg-3"
    style={{ position: "relative", paddingLeft: "60px" }} // Reserve space for flag
  >
    <img
      src="https://images.ctfassets.net/79nimht05j33/1TgzxBjOEdUibkkiUQqthH/a2139e7831ead1f0ce818dd0135dcc12/usa-flag.jpg"
      alt="Made in USA"
      className="usa-flag"
      style={{
        width: "55px",
        position: "absolute",
        left: "0", // No negative value, stays fixed at left
        top: "50%",
        transform: "translateY(-50%)",
      }}
    />
    <div>
      <p className="sitelinehead">Your #1 Home Improvement Experts</p>
      <p className="areasservedheader">
        {personalizedServingText(this.props.pageProps.path)}
      </p>
    </div>
  </SiteTagline>
) : null}






              <div className="d-none d-lg-flex align-items-center col-lg-5 col-xl-4 justify-content-end">
                <CallToAction {...this.props} />
              </div>

              <MenuMobile className="d-lg-none d-xl-none col-6 d-flex align-items-center justify-content-end">
                <MobileIconBurger onClick={this.toggleMobileMenuOverlay}>
                  {this.state.headerOpen ? (
                    <>
                      <X size={30} />
                      <span className="sr-only">Close Menu</span>
                    </>
                  ) : (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="5" y1="12" x2="23" y2="12" />
                        <line x1="2" y1="6" x2="23" y2="6" />
                        <line x1="8" y1="18" x2="23" y2="18" />
                      </svg>
                      <span className="sr-only">Open Menu</span>
                    </>
                  )}
                </MobileIconBurger>
              </MenuMobile>
            </div>
          </div>

          <SiteTagline
            className={`mobileareaserved container padding-0 ${
              !this.props.pageProps.path.includes('blog') ? 'hidden' : ''
            }`}
          >
            <p>
              {personalizedServingText(this.props.pageProps.path)}
            </p>
          </SiteTagline>
        </HeaderOuterContainer>

        <NavOuterContainer className="menu-desktop d-none d-lg-flex align-items-center">
          <div className="container">
            <ul>
              <MainNavigation
                pageLocation={this.props.pageProps.location.pathname}
                mainNavigation={this.state.defaultMenu}
                refCallback={this.refCallback}
              />
            </ul>
          </div>
        </NavOuterContainer>

        <StickyContainer>
          <MobileSecondaryCTA className="d-lg-none d-xl-none">
            <div className="container">
              <CallToAction
                {...this.props}
                className="d-lg-none d-xl-none col-6 d-flex align-items-center"
              />
            </div>
          </MobileSecondaryCTA>
        </StickyContainer>
        <div
          className={'mobileOverlay' + (this.state.headerOpen ? ' open' : '')}
        >
          <div className="animate-overlay-content">
            <NavigationMobileUL>
              <MainNavigation
                mainNavigation={this.state.defaultMenu}
                pageLocation={this.props.pageProps.location.pathname}
              />
            </NavigationMobileUL>
          </div>
        </div>
      </>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  siteDescription: PropTypes.string,
  mainNavigation: PropTypes.array,
}

Header.defaultProps = {
  siteTitle: '',
  siteDescription: '',
  mainNavigation: '',
}

export default Header
